import { withRouteInformation } from 'components/withRouteInformation';
import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import { RootStore } from 'redux/store';

export interface PrivateRouteProps extends RouteProps {
	component: React.FC;
	pathname: string;
}

const PrivateRoute: React.FC<PrivateRouteProps> = (props: PrivateRouteProps) => {
	const teams = useSelector((state: RootStore) => state.user.teams);
	const hasAcceptedTerms = useSelector((state: RootStore) => state.user.hasAcceptedTerms);
	const { component, pathname, ...otherProps } = props;
	const teamId = pathname.split('/')[2];
	let userIsInTeam = false;

	for (const team of teams) {
		if (team.teamId === teamId) {
			userIsInTeam = true;
		}
	}

	if (!hasAcceptedTerms) {
		return <Redirect to='/' push />
	} else if (!userIsInTeam) {
		return <Redirect to='/team' push />
	} else {
		return <Route {...otherProps} component={component} />
	}
};

export default withRouteInformation(PrivateRoute);
